import React, { useContext } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import RoutePath from '../../../pure-js/libs/RoutePath'
import { FeatureFlagsContext, FlagNames } from '../libs/FeatureFlags'
import { ActivityDetailPage } from '../pages/ActivityDetailPage'
import FeatureFlagsAdminPage from '../pages/FeatureFlagsAdminPage'
import IframePage from '../pages/IframePage'
import PayPage from '../pages/PayPage'
import PaySuccessPage from '../pages/PaySuccessPage'
import { PublicActivitiesPage } from '../pages/PublicActivitiesPage'
import RegisterPage from '../pages/RegisterPage'
import SettingsEmailsPage from '../pages/SettingsEmailsPage'
import { RootPage } from '../pages/SignInPage'
import StaticDemoPage from '../pages/StaticDemoPage'
import SwishPayPage from '../pages/SwishPayPage'
import TestPage from '../pages/TestPage'
import EmptyActivity from './EmptyActivity'
import SandboxPage from './SandboxPage'
import { UrlShortRedirectPage } from '../pages/UrlShortRedirectPage'
import CheckoutPage from '../pages/CheckoutPage'
import PrivateLessonsCheckoutPage from '../pages/PrivateLessonsCheckoutPage'
import PrivateLessonsPortalPage from '../pages/PrivateLessonsPortalPage'
import PrivateLessonOrderPage from '../pages/PrivateLessonOrderPage'
import DropinTicketDetailPage from '../pages/DropinTicketDetailPage'
import { PortalLoginPage } from '../pages/PortalLoginPage'
import { PortalLogoutPage } from '../pages/PortalLogoutPage'
import { PortalViewAsLandingPage } from '../pages/PortalViewAsLandingPage'
import { PortalViewAsEndedPage } from '../pages/PortalViewAsEndedPage'
import { PortalHomePage } from '../pages/PortalHomePage'
import { PortalDashboardPage } from '../pages/PortalDashboardPage'
import { PortalDropinTicketsPage } from '../pages/portal-dropin-tickets'
import { PortalWalkinTicketsPage } from '../pages/portal-walkin-tickets'
import { PortalEnrollmentsPage } from '../pages/portal-enrollments'
import { PortalProfilePage } from '../pages/PortalProfilePage'
import { PortalLayout } from './portal/PortalLayout'
import { ProtectedRoute } from './ProtectedRoute'
import { PortalAuthProvider } from '../hooks/usePortalAuth'

const NavigationPublicRoutes: React.FC = () => {
  const { isFeatureEnabled, getStorageKey } = useContext(FeatureFlagsContext)

  const FeatureFlagsPage = () => {
    return <FeatureFlagsAdminPage storageKey={getStorageKey()} />
  }

  return (
    <PortalAuthProvider>
      <Routes>
        <Route path={RoutePath.INCORRECT_ROUTE} Component={EmptyActivity} />
        <Route path={RoutePath.ROOT} Component={RootPage} />
        <Route path={RoutePath.URL_SHORT_REDIRECT} Component={UrlShortRedirectPage} />
        <Route path={RoutePath.ACTIVITY_DETAIL} Component={ActivityDetailPage} />
        <Route path={RoutePath.ACTIVITY_DETAIL_SEO} Component={ActivityDetailPage} />
        <Route path={RoutePath.SANDBOX} Component={SandboxPage} />
        <Route path={RoutePath.IFRAME} Component={IframePage} />
        <Route path={RoutePath.DEMOPAGE} Component={StaticDemoPage} />
        <Route path={RoutePath.PAY} Component={PayPage} />
        <Route path={RoutePath.PAY_SUCCESS} Component={PaySuccessPage} />
        <Route path={RoutePath.REGISTER} Component={RegisterPage} />
        <Route path={RoutePath.REGISTER_SEO} Component={RegisterPage} />
        <Route path={RoutePath.SWISH_PAY} Component={SwishPayPage} />
        <Route path={RoutePath.PUBLIC_ACTIVITIES} Component={PublicActivitiesPage} />
        <Route path={RoutePath.PUBLIC_ACTIVITIES_PREVIEW} Component={PublicActivitiesPage} />
        <Route path={RoutePath.TEST} Component={TestPage} />
        <Route path={RoutePath.FEATURES} Component={FeatureFlagsPage} />
        <Route path={RoutePath.REGISTER_OBFUSCATED} Component={RegisterPage} />
        <Route path={RoutePath.CHECKOUT} Component={CheckoutPage} />
        <Route path={RoutePath.PRIVATE_LESSONS_CHECKOUT} Component={PrivateLessonsCheckoutPage} />
        <Route path={RoutePath.PRIVATE_LESSON_ORDER} Component={PrivateLessonOrderPage} />
        <Route path={RoutePath.PRIVATE_LESSONS_PORTAL} Component={PrivateLessonsPortalPage} />
        <Route path={RoutePath.DROPIN_TICKET_DETAIL} Component={DropinTicketDetailPage} />

        {/* Portal Routes */}
        <Route path={RoutePath.PORTAL_LOGIN} Component={PortalLoginPage} />
        <Route path={RoutePath.PORTAL_VIEW_AS} Component={PortalViewAsLandingPage} />
        <Route path={RoutePath.PORTAL_VIEW_AS_ENDED} Component={PortalViewAsEndedPage} />
        <Route
          path={RoutePath.PORTAL}
          element={
            <ProtectedRoute>
              <PortalLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<PortalDashboardPage />} />
          <Route path="home" element={<Navigate to="home/orders" replace />} />
          <Route path="home/orders" element={<PortalHomePage />} />
          <Route path="home/orders/:orderId" element={<PortalHomePage />} />
          <Route path="home/occasions" element={<PortalHomePage />} />
          <Route path="private-lessons" element={<Navigate to="/portal/home/orders" replace />} />
          <Route path="dropin-tickets/:dropinTicketId" element={<PortalDropinTicketsPage />} />
          <Route path="dropin-tickets" element={<PortalDropinTicketsPage />} />
          <Route path="walkin-tickets/:paymentRef" element={<PortalWalkinTicketsPage />} />
          <Route path="walkin-tickets" element={<PortalWalkinTicketsPage />} />
          <Route path="enrollments/:enrollmentId" element={<PortalEnrollmentsPage />} />
          <Route path="enrollments" element={<PortalEnrollmentsPage />} />
          <Route path="profile" element={<PortalProfilePage />} />
        </Route>
        <Route
          path={RoutePath.PORTAL_LOGOUT}
          element={
            <ProtectedRoute>
              <PortalLogoutPage />
            </ProtectedRoute>
          }
        />

        {isFeatureEnabled(FlagNames.BETA) && <Route path={RoutePath.SETTINGS_EMAILS} Component={SettingsEmailsPage} />}
      </Routes>
    </PortalAuthProvider>
  )
}

export default NavigationPublicRoutes
